// extracted by mini-css-extract-plugin
export default {"changeBtn":"style_changeBtn__PyRbT","changeBlock":"style_changeBlock__t6ldp"};